export default __webpack_public_path__ + "static/Evergreen-Badge-a0f54debac3b7c04bc3e8922b67d762a.webp";